<template>
  <div class="single-choice-container">
    <v-radio-group :value="selectedChoice" class="ma-0 mt-2" :items="question.choices" item-text="title" item-value="id" hide-details @change="handleChange">
      <v-radio
        v-for="choice in question.choices"
        :key="choice.id"
        class="pb-6 ma-0"
        :color="getAssets.colors.form.buttonBackground"
        :value="choice.id"
        hide-details
      >
        <template #label>
          <span class="choice-title">{{ choice.title }}</span>
        </template>
      </v-radio>
    </v-radio-group>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'SingleChoice',
  props: {
    question: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedChoice: null
    }
  },
  computed: {
    ...mapGetters(['GET_ASSETS']),
    getAssets() {
      return this.GET_ASSETS
    },
    invalidAnswer() {
      return false
    }
  },
  watch: {
    question: {
      handler(newVal) {
        this.selectedChoice = newVal.answers?.[0]
      },
      deep: true
    }
  },
  methods: {
    handleChange(value) {
      this.$emit('change', [value])
    }
  }
}
</script>

<style scoped lang="scss">
.single-choice-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 8px;
}

.choice-title {
  font-size: 14px;
  font-weight: normal;
  color: #6b7580;
}
</style>
